/* eslint-disable default-case */
import DateFnsUtils from "@date-io/date-fns";
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import axios from "axios";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { setSnackbar } from "../../../redux/snackbar";
import store from "../../../redux/store";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { OutlineInput } from "../../components/forms/OutlineInput";
import OpcSelect from "../../components/select/src";
import { Alert } from "../../util/alerts";
import { Tracker } from "../../util/analytics";
import {
  API_DATE_FORMAT,
  API_ENDPOINTS,
  API_ENDPOINT_BASE_URL,
} from "../../util/constants";
import * as helpers from "../../util/helpers";
import { getDispositions } from "../../util/helpers";
import { validatePhoneNumber } from "../../util/phoneUtil";
import * as crmConstants from "../CRM/constants";
import * as c2cConstants from "../Ticker/constants";
import { callAPi, getTickerState } from "./CallService";
import * as constants from "./constants";
import { LiveCallMinimized } from "./LiveCallMinimized";
import { actionTypes } from "./reducer";
import { TelInput } from "./TelInput";

export function LiveCallAddCustomer(props) {
  const dispatch = useDispatch();

  const call_state = useSelector((state) => {
    return state.ticker.call_state;
  });

  const wrap_up_time = useSelector((state) => {
    return state.ticker.wrap_up_time;
  });

  const [selectedDate, handleDateChange2] = useState(new Date());
  const [counterState, setCounterState] = useState(0);

  const [noteOpenState, setNoteOpenState] = useState(false);
  const [fnoteOpenState, setFNoteOpenState] = useState(false);
  
  const handleDateChange = (date) => {
    let date1 = date;
    handleDateChange2(date1);
    onInputChange("followup_dt", date1, "forceValidate", false);
  };

  const setViewState = (view_state) => {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: { view_state: view_state },
    });
  };

  const [customer, setCustomer] = useState(props.customer);
  let phonebook = customer ? customer.phonebook : null;
  let customer_id = customer && customer.id ? customer.id : null;
  let editMode = customer && customer.id ? "edit" : "add";
  let [phonenumbers_set, setPhonenumbers_set] = useState(
    phonebook && phonebook.phonenumbers_set ? phonebook.phonenumbers_set : []
  );

  useEffect(() => {
    if (props.customer) {
    setCustomer(props.customer);
    let phonebook = props.customer ? props.customer.phonebook : null;
    let editMode = props.customer && props.customer.id ? "edit" : "add";
    setPhonenumbers_set(
      phonebook && phonebook.phonenumbers_set ? phonebook.phonenumbers_set : []
    );
    // onInputChange(
    //   "note",
    //   customer?.customerCallLogs?.customer_detail &&
    //     customer?.customerCallLogs?.customer_detail["note"]
    // );
    if (editMode === "edit") {
      setNoteOpenState(true);
      setFNoteOpenState(true);
    }
    }
  }, [props.customer]);

  let initialValues = {
    email: phonebook ? phonebook.email : "",
    name: phonebook ? phonebook.name : "",
    number:
      editMode === "add"
        ? props.phone_number
          ? props.phone_number
          : customer.phone_number
        : phonenumbers_set
        ? phonenumbers_set[0]["number"]
        : "",
    company: phonebook ? phonebook.company : "",
    additional_info_1: customer ? customer?.additional_info_1 : "",
    additional_info_2: customer ? customer?.additional_info_2 : "",
    // status: customer && customer.status ? customer.status : "",
    status: "",
    followup_notes: null,
    note: null,
    followup_dt: null,
    phonenumbers_set: phonenumbers_set,
  };

  const [isDirty, setDirty] = useState(false);
  const [values, setValues] = React.useState(
    JSON.parse(JSON.stringify(initialValues))
  );

  const initialValidations = {
    email: "",
    name: "",
    number: "",
    company: "",
    additional_info_1: "",
    additional_info_2: "",
    status: "",
    followup_notes: null,
    note: null,
    followup_dt: null,
  };

  const [validations, _setValidations] = React.useState(
    JSON.parse(JSON.stringify(initialValidations))
  );

  const setValidations = (validations) => {
    let _hasErrors = false;
    Object.keys(validations).map((v, i) => {
      if (validations[v] && validations[v] >= 400) {
        _hasErrors = true;
      }
    });
    _setValidations(validations);
  };

  const onCancel = () => {
    setValidations(JSON.parse(JSON.stringify(initialValidations)));
    setValues(JSON.parse(JSON.stringify(initialValues)));
    if (props.via !== "crm-customer") {
      if (props.back) {
        props.back();
      } else {
        const previous_view_state = getTickerState().previous_view_state;
        if (previous_view_state) {
          setViewState(previous_view_state);
        } else {
          setViewState(constants.CALL_VIEW_STATES.CALL_VIEW);
        }
      }
    } else {
      props.back();
    }
    return;
  };

  const [assignedLeadObject, setAssignedLeadObject] = useState("");
  const fetchAssignedLeadData = async () => {
    const url = API_ENDPOINTS.getAgentsListingsForAdmin;
    const params = {
      agent_id: customer?.agent_id,
      limit: 1,
    };
    const response = await axios.get(url, { params: params });
    const makeDataPacketForSelect = {
      label:
        response.data.objects[0].first_name +
        response.data.objects[0].last_name,
      value: response.data.objects[0].contact_number,
    };
    setAssignedLeadObject(makeDataPacketForSelect);
  };
  useEffect(() => {
    if(helpers.isAdmin() || helpers.isSuperVisor()) fetchAssignedLeadData();
  }, []);

  const is_disposition_enabled = useSelector((state) => {
    return state.auth.is_disposition_enabled;
  });
  const [dispositions, setDispositons] = useState(null);
  const [selectedDisposition, setSelectedDisposition] = useState("");
  const [selectedDispositionObject, setSelectedDispositionObject] = useState(
    null
  );

  const onSelectDisposition = (code, name) => {
    const customLabels1 = {};
    const values_codes = [];

    if (!dispositions) return;
    dispositions.map((d, i) => {
      if (d.id + "" === code || d.name === name) {
        setSelectedDisposition(code ? code : d.id + "");
        setSelectedDispositionObject(d);

        d.sub_levels.map((s, si) => {
          let option = {
            data: d,
            primary: s.name,
            secondary: "",
          };
          let key = s.id + "";
          customLabels1[key] = option;
          values_codes.push(key);
        });

        setValueCodesForSubDispositions(values_codes);
        setCustomLabelsForSubDispositions(customLabels1);
      }
    });
  };

  const [
    customLabelsForDispositions,
    setCustomLabelsForDispositions,
  ] = useState({});
  const [valueCodesForDispositions, setValueCodesForDispositions] = useState(
    []
  );

  const [selectedSubDisposition, setSelectedSubDisposition] = useState("");
  const [
    selectedSubDispositionObject,
    setSelectedSubDispositionObject,
  ] = useState(null);

  const [
    customLabelsForSubDispositions,
    setCustomLabelsForSubDispositions,
  ] = useState({});
  const [
    valueCodesForSubDispositions,
    setValueCodesForSubDispositions,
  ] = useState([]);

  const onSelectSubDisposition = (code, name) => {
    if (selectedDispositionObject && selectedDispositionObject.sub_levels) {
      selectedDispositionObject.sub_levels.map((s, si) => {
        if (s.id + "" === code || s.name === name) {
          setSelectedSubDisposition(code ? code : s.id + "");
          setSelectedSubDispositionObject(s);
        }
      });
    }
  };

  // useEffect(() => {
  //   if (
  //     editMode === "edit" &&
  //     customer &&
  //     customer?.customerdisposition_set &&
  //     customer?.customerdisposition_set?.current
  //   )
  //     onSelectDisposition(
  //       null,
  //       customer["customerdisposition_set"]["current"]["level1"]
  //         ? customer["customerdisposition_set"]["current"]["level1"]
  //         : ""
  //     );
  // }, [dispositions]);

  // useEffect(() => {
  //   if (
  //     editMode === "edit" &&
  //     customer &&
  //     customer?.customerdisposition_set &&
  //     customer?.customerdisposition_set?.current
  //   )
  //     onSelectSubDisposition(
  //       null,
  //       customer["customerdisposition_set"]["current"]["level2"]
  //         ? customer["customerdisposition_set"]["current"]["level2"]
  //         : ""
  //     );
  // }, [selectedDispositionObject]);

  useEffect(() => {
    if (editMode === "edit")
      handleDateChange2(new Date()
        // customer &&
        //   new Date(customer.followup_dt) instanceof Date &&
        //   !isNaN(new Date(customer.followup_dt).valueOf())
        //   ? customer.followup_dt
        //   : new Date()
      );
  }, [customer]);

  const [changed, setChanged] = useState(1);
  const [msg, setMsg] = useState(null);
  const reset = () => {
    setMsg(null);
  };

  const toggle = (key) => {
    switch (key) {
      case "note": {
        setNoteOpenState((prev) => !prev);
        break;
      }
      case "fnote": {
        setFNoteOpenState((prev) => !prev);
        break;
      }

      default:
        return;
    }
  };

  useEffect(() => {
    if (
      props.via !== "crm-customer" &&
      call_state === constants.CALL_STATES.CALL_WRAPUP
    ) {
      let dirty = isDirty;
      if (values["note"] !== initialValues["note"]) {
        dirty = true;
      }
      if (values["followup_notes"] !== initialValues["followup_notes"]) {
        dirty = true;
      }
      if (values["followup_dt"] !== initialValues["followup_dt"]) {
        dirty = true;
      }
      if (values["status"] !== initialValues["status"]) {
        dirty = true;
      }
      if (selectedDispositionObject) {
        dirty = true;
      }
      if (dirty) {
        onSave();
        setCounterState(counterState + 1);
        dispatch({
          type: "onCallEvent",
          payload: {
            call_state: constants.CALL_STATES.CALL_HANGUP,
            view_state: constants.CALL_VIEW_STATES.CALL_NONE,
            window_state_counter: counterState + 1,
            window_state: constants.C2C_CONSTANTS.WINDOW_STATE_CLOSED,
          },
        });
      } else {
        setCounterState(counterState + 1);
        dispatch({
          type: "onCallEvent",
          payload: {
            call_state: constants.CALL_STATES.CALL_HANGUP,
            view_state: constants.CALL_VIEW_STATES.CALL_NONE,
            window_state_counter: counterState + 1,
            window_state: constants.C2C_CONSTANTS.WINDOW_STATE_CLOSED,
          },
        });
      }
    }
  }, [call_state]);

  useEffect(() => {
    const get = async () => {
      const response = await getDispositions();
      if (
        response &&
        response.status === 200 &&
        response.data &&
        response.data.dispositions
      ) {
        setDispositons(response.data.dispositions);
        const customLabels1 = {};
        const values_codes = [];
        response.data.dispositions.map((d, i) => {
          let option = {
            data: d,
            primary: d.name,
            secondary: "",
          };
          let key = d.id + "";
          customLabels1[key] = option;
          values_codes.push(key);
        });

        setValueCodesForDispositions(values_codes);
        setCustomLabelsForDispositions(customLabels1);
      }
    };
    if (store.getState().auth.is_disposition_enabled) {
      get();
    }
  }, []);

  const [dataForLeadAddForm, setDataForLeadAddForm] = useState(null);
  const getAssignLeadData = (data) => {
    setDataForLeadAddForm(data);
  };

  const onSave = async () => {
    let errors = false;
    const validationsUpdated = { ...validations };
    if (
      onInputChange(
        "email",
        values.email,
        "forceValidate",
        validationsUpdated
      ) !== 200
    )
      errors = true;
    if (
      onInputChange(
        "name",
        values.name,
        "forceValidate",
        validationsUpdated
      ) !== 200
    )
      errors = true;
    if (
      onInputChange(
        "company",
        values.company,
        "forceValidate",
        validationsUpdated
      ) !== 200
    )
      errors = true;
    if (
      props.via !== "crm-customer" &&
      onInputChange(
        "followup_dt",
        values.followup_dt,
        "forceValidate",
        validationsUpdated
      ) !== 200
    )
      errors = true;
    if (
      props.via === "crm-customer" &&
      onInputChange(
        "numbers",
        phonenumbers_set,
        "forceValidate",
        validationsUpdated
      ) !== 200
    )
      errors = true;
    if (
      props.via !== "crm-customer" &&
      onInputChange(
        "number",
        values.number,
        "forceValidate",
        validationsUpdated
      ) !== 200
    )
      errors = true;

    if (errors) {
      setValidations(validationsUpdated);
      return;
    }

    try {
      await _onSave();
    } catch (error) {}
  };
  const _onSave = async () => {
    let response = null;
    let method = "POST";
    if (!customer || !customer.id) {
      const data = {
        call_id: props.call_id ? props.call_id : null,
        status: values.status ? values.status : "",
        followup_dt: values.followup_dt
          ? moment(values.followup_dt).format(API_DATE_FORMAT)
          : null,
        followup_notes: values.followup_notes ? values.followup_notes : null,
        company: values.company ? values.company : "",
        additional_info_1: values.additional_info_1 ? values.additional_info_1 : null,
        additional_info_2: values.additional_info_2 ? values.additional_info_2 : null,
        email: values.email ? values.email : "",
        name: values.name ? values.name : "",
        note: values.note
          ? (moment().format('DD MMM YYYY h:mm')).toString() + ' ' + values.note
          : null,
      };

      if (props.via === "crm-customer") {
        let numbers = [];
        phonenumbers_set.map((num, i) => {
          numbers.push(num.number);
        });
        data["numbers"] = numbers;
      } else {
        data["numbers"] = [values.number];
      }

      if (selectedDispositionObject) {
        let d = {
          group_id: selectedDispositionObject.group_id,
          level1: selectedDispositionObject.name,
          level2: null,
        };
        if (selectedSubDispositionObject) {
          d.level2 = selectedSubDispositionObject.name;
        }
        data.disposition = d;
      } else {
        let d = {
          group_id: null,
          level1: null,
          level2: null,
        };
        data.disposition = d;
      }

      let newDataPacket = {
        callid: props.call_id ? props.call_id : null,
        status: values.status ? values.status : "",
        "followup-date": values.followup_dt
          ? moment(values.followup_dt).format(API_DATE_FORMAT)
          : null,
        "follow-up": values.followup_notes ? values.followup_notes : null,
        note: values.note ? values.note : null,
        "disposition-name": selectedDispositionObject
          ? selectedDispositionObject.name
          : "",
        "sub-disposition-name": selectedSubDispositionObject
          ? selectedSubDispositionObject.name
          : "",
        disposition: selectedDispositionObject
          ? selectedDispositionObject.id
          : "",
        "sub-disposition": selectedSubDispositionObject
          ? selectedSubDispositionObject.id
          : "",
        number: values.number && typeof values.number === "string"
          ? [values.number]
          : values.number,
        company: values.company ? values.company : "",
        email_id: values.email ? values.email : "",
        name: values.name ? values.name : "",
      };

      response = await callAPi("/newsr/api/v1/customer/", method, data)
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            if (props.via !== "crm-customer") {
              callAPi("/newsr/customer_detail", "POST", newDataPacket);
            }
            dispatch(
              setSnackbar(true, "success", "Customer added successfully")
            );
            return { status: 200, data: res.data };
          } else {
            return { status: res.status };
          }
        });
    } else {
      let newData = {
        additional_info_1: values.additional_info_1 ? values.additional_info_1 : null,
        additional_info_2: values.additional_info_2 ? values.additional_info_2 : null,
        status: values.status ? values.status : "",
        followup_dt: values.followup_dt
          ? moment(values.followup_dt).format(API_DATE_FORMAT)
          : null,
        followup_notes: values.followup_notes ? values.followup_notes : null,
        note: values.note
          ? (moment().format('DD MMM YYYY h:mm')).toString() + ' ' + values.note
          : null,
      };

      let newDataPacket = {
        callid: props.call_id ? props.call_id : null,
        status: values.status
          ? values.status
          : !values.status
          ? customer["status"]
          : "",
        "followup-date": values.followup_dt
          ? moment(values.followup_dt).format(API_DATE_FORMAT)
          : !values.followup_dt
          ? customer["followup_dt"] === "None"
            ? moment(selectedDate).format(API_DATE_FORMAT)
            : customer["followup_dt"]
          : null,
        "follow-up": values.followup_notes
          ? values.followup_notes
          : !values.followup_notes
          ? customer["followup_notes"]
          : null,
        note: values.note ? values.note : null,
        "disposition-name": selectedDispositionObject
        ? selectedDispositionObject.name
        : "",
        "sub-disposition-name": selectedSubDispositionObject
        ? selectedSubDispositionObject.name
        : "",
        disposition: selectedDispositionObject
          ? selectedDispositionObject.id
          : "",
        "sub-disposition": selectedSubDispositionObject
          ? selectedSubDispositionObject.id
          : "",
        number:
          values.number && typeof values.number === "string"
            ? [values.number]
            : values.number,
        company: values.company ? values.company : "",
        email_id: values.email ? values.email : "",
        name: values.name ? values.name : "",
      };

      if (!newData.status) {
        newData.status = customer["status"];
      }
      if (!newData.followup_dt) {
        newData.followup_dt = customer["followup_dt"];
      }
      if (!newData.followup_notes) {
        newData.followup_notes = customer["followup_notes"];
      }
      if (!newData.note) {
        newData.note = customer["note"];
      }

      let newPhonebook = {
        ...customer["phonebook"],
        company: values.company ? values.company : "",
        email: values.email ? values.email : "",
        name: values.name ? values.name : "",
      };

      newPhonebook["phonenumbers_set"] = phonenumbers_set;
      let numbers = [];
      phonenumbers_set.map((num, i) => {
        numbers.push(num.number);
      });

      if (numbers.length > 0) {
        newData["numbers"] = numbers;
      }

      if (selectedDispositionObject) {
        let d = {
          group_id: selectedDispositionObject.group_id,
          level1: selectedDispositionObject.name,
          level2: null,
        };
        if (selectedSubDispositionObject) {
          d.level2 = selectedSubDispositionObject.name;
        }
        newData.customerdisposition_set = { current: d };
      } else {
        let d = {
          group_id: null,
          level1: null,
          level2: null,
        };
        newData.customerdisposition_set = { current: d };
      }

      const data = {
        ...customer,
        ...newData,
        phonebook: newPhonebook,
        ...(props.call_id && { call_id: props.call_id }),
      };

      response = await axios
        .put(
          API_ENDPOINT_BASE_URL + "/newsr/api/v1/customer/" + customer_id + "/",
          data,
          {}
        )
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            if (props.via !== "crm-customer") {
              callAPi("/newsr/customer_detail", "POST", newDataPacket);
            }
            dispatch(
              setSnackbar(true, "success", "Customer added successfully")
            );
            return { status: 200, data: res.data };
          } else {
            return { status: res.status };
          }
        });
    }
    if (response && (response.status === 200 || response.status === 201)) {
      setValidations(JSON.parse(JSON.stringify(initialValidations)));
      setValues(JSON.parse(JSON.stringify(initialValues)));

      if (props.via !== "crm-customer") {
        setViewState(constants.CALL_VIEW_STATES.CALL_VIEW);
      } else {
        props.onSuccess(response);
      }

      if (props.onUpdated) {
        props.onUpdated(response.data);
      }
    } else {
      setChanged(changed + 1);
      if (
        response.response &&
        response.response.data &&
        response.response.data.error_message
      ) {
        setMsg(response.response.data.error_message);
      } else {
        if (
          response.response &&
          response.response.data &&
          response.response.data.status
        ) {
          if (response.response.data.status["duplicates"]) {
            handlePhoneErrors(response.response.data.status);
          }
        } else if (
          response.response.data &&
          response.response.data.error &&
          response.response.data.error.message
        ) {
          setMsg(response.response.data.error.message);
        } else {
          setMsg("Error occured.");
        }
      }
    }
  };

  const onEvent = (event) => {
    switch (event.type) {
      case "c2c_form::set": {
        switch (event.key) {
          case "customer_number": {
            if (event.valueObject) {
              event.valueObject["number"] = event.value;
              let phonenumbers_set1 = [...phonenumbers_set];

              phonenumbers_set1.map((num, i) => {
                if (event.valueIndex === i) {
                  phonenumbers_set1[i] = event.valueObject;
                  setPhonenumbers_set(phonenumbers_set1);
                }
              });

              onInputChange("numbers", phonenumbers_set1);
            } else {
              onInputChange("number", event.value);
            }
            break;
          }
          default:
            break;
        }
      }
    }
  };

  const onInputChange = (name, value, event, validationsUpdatedCurrent) => {
    const modelUpdated = { ...values };
    const validationsUpdated = validationsUpdatedCurrent
      ? validationsUpdatedCurrent
      : { ...validations };

    let valueUpdated = true;
    modelUpdated[name] = value;
    setValues(modelUpdated);
    let valdiateError = true;
    let validateCorrectionsOnly = false;

    if (event !== "forceValidate") {
      if (valueUpdated) {
        if (event === "onBlur") {
          validateCorrectionsOnly = true;
        } else {
          valdiateError = false;
        }
      } else {
        return;
      }
    }
    const valid_key = name;
    switch (name) {
      case "name": {
        if (value.length < 3 || value.length > 30) {
          if (valdiateError && !validateCorrectionsOnly) {
            validationsUpdated[valid_key] = 400;
            setValidations(validationsUpdated);
          }
        } else if (
          !Yup.string()
            .matches(/^[0-9aA-zZ\s]+$/)
            .isValidSync(value)
        ) {
          if (valdiateError && !validateCorrectionsOnly) {
            validationsUpdated[valid_key] = 401;
            setValidations(validationsUpdated);
          }
        } else {
          validationsUpdated[valid_key] = 200;
          setValidations(validationsUpdated);
        }

        if (value !== initialValues["name"]) {
          setDirty(true);
        }

        break;
      }

      case "company": {
        if (
          value &&
          value.length > 0 &&
          (value.length < 3 || value.length > 50)
        ) {
          if (valdiateError && !validateCorrectionsOnly) {
            validationsUpdated[valid_key] = 400;
            setValidations(validationsUpdated);
          }
        } else {
          validationsUpdated[valid_key] = 200;
          setValidations(validationsUpdated);
        }

        if (value !== initialValues["company"]) {
          setDirty(true);
        }

        break;
      }

      case "email": {
        if (
          value.length > 0 &&
          (!Yup.string()
            .matches(
              /^[a-zA-Z0-9_.+]+@[a-zA-Z0-9-]+(.[a-zA-Z0-9]+)*\.[a-zA-Z0-9]{2,}$/i
            )
            .isValidSync(value) ||
            !Yup.string()
              .email()
              .isValidSync(value))
        ) {
          if (valdiateError && !validateCorrectionsOnly) {
            validationsUpdated[valid_key] = 400;
            setValidations(validationsUpdated);
          }
        } else {
          validationsUpdated[valid_key] = 200;
          setValidations(validationsUpdated);
        }

        if (value !== initialValues["email"]) {
          setDirty(true);
        }
        break;
      }

      case "number":
      case "numbers": {
        if (props.via !== "crm-customer") {
          if (!validatePhoneNumber(value)) {
            if (valdiateError && !validateCorrectionsOnly) {
              validationsUpdated[valid_key] = 400;
              setValidations(validationsUpdated);
            }
          } else {
            validationsUpdated[valid_key] = 200;
            setValidations(validationsUpdated);
          }

          if (value !== initialValues["number"]) {
            setDirty(true);
          }
          break;
        } else {
          let val = value;
          if (val) {
            let hasErrors = false;
            val.map((pn, i) => {
              if (!validatePhoneNumber(pn.number)) {
                if (valdiateError && !validateCorrectionsOnly) {
                  validationsUpdated["number_" + i] = 400;
                  validationsUpdated["numbers"] = 400;
                  hasErrors = true;
                  setValidations(validationsUpdated);
                }
              } else {
                validationsUpdated["number_" + i] = 200;
                setValidations(validationsUpdated);
              }
            });
            if (!hasErrors) {
              validationsUpdated["numbers"] = 200;
            }
            return validationsUpdated["numbers"];
          }
        }
      }

      case "followup_dt": {
        if (value && moment(value) < moment()) {
          if (valdiateError && !validateCorrectionsOnly) {
            validationsUpdated[valid_key] = 400;
            setValidations(validationsUpdated);
          }
        } else {
          validationsUpdated[valid_key] = 200;
          setValidations(validationsUpdated);
        }

        if (value !== initialValues["followup_dt"]) {
          setDirty(true);
        }
        break;
      }
    }

    return validationsUpdated[valid_key];
  };

  const getValidationMsg = (key) => {
    if (key === "number") {
      if (validations && validations[key] === 400) {
        if (values[key] && values[key].length > 1) {
          return (
            <FormHelperText className="text-danger">
              Phone number is not valid
            </FormHelperText>
          );
        } else {
          return (
            <FormHelperText className="text-danger">
              Required field
            </FormHelperText>
          );
        }
      }

      if (validations && validations[key] === 403) {
        return (
          <FormHelperText className="text-danger">
            Phone number already exists
          </FormHelperText>
        );
      }
    }

    if (key.includes("number_") && phonenumbers_set) {
      for (var i = 0; i < phonenumbers_set.length; i++) {
        if ("number_" + i === key) {
          var pn = phonenumbers_set[i];

          if (validations && validations[key] === 400) {
            if (pn.number && pn.number.length > 1) {
              return (
                <FormHelperText className="text-danger">
                  Phone number is not valid
                </FormHelperText>
              );
            } else {
              return (
                <FormHelperText className="text-danger">
                  Required field
                </FormHelperText>
              );
            }
          }

          if (validations && validations[key] === 403) {
            return (
              <FormHelperText className="text-danger">
                Phone number already exists
              </FormHelperText>
            );
          }
        }
      }
    }

    return <></>;
  };

  const handlePhoneErrors = (status) => {
    if (!status || !status.duplicates) return;
    if (props.via !== "crm-customer") {
      const validationsUpdated = { ...validations };
      validationsUpdated["number"] = 403;
      setValidations(validationsUpdated);
    } else {
      if (!phonenumbers_set) return;
      let hasErrors = false;
      const validationsUpdated = { ...validations };
      phonenumbers_set.map((pn, i) => {
        if (status.duplicates.includes(pn.number)) {
          validationsUpdated["number_" + i] = 403;
          validationsUpdated["numbers"] = 400;
          hasErrors = true;
        } else {
          validationsUpdated["number_" + i] = 200;
        }
      });
      if (!hasErrors) {
        validationsUpdated["numbers"] = 200;
      }

      setValidations(validationsUpdated);
    }
  };

  return (
    <>
      <div className="tmodal tmodal-dialog-scrollable call-ticker-dialog-sec crm-forms">
        <div className="tmodal-content">
          {props.via !== "crm-customer" && (
            <LiveCallMinimized disableProgress={true} {...props} />
          )}
          <div className="ticker-header-title">
            <div className="d-flex justify-content-between">
              {props.via === "crm-customer" && (
                <NavLink to={"/customer-management"}>
                  <button className="outline-btn px-2 py-1 btn btn-primary">
                    <img
                      alt=""
                      className="back-icn"
                      src={toAbsoluteUrl("/media/sr/icons/crm/back-arrow.svg")}
                    />
                  </button>
                </NavLink>
              )}
              {props.via !== "crm-customer" && (
                <div className="back-section">
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      Tracker.event(
                        c2cConstants.ANALYTICS.C2C_CUST_BACK[0],
                        c2cConstants.ANALYTICS.C2C_CUST_BACK[1],
                        c2cConstants.ANALYTICS.C2C_CUST_BACK[2],
                        c2cConstants.ANALYTICS.C2C_CUST_BACK[3],
                        helpers.getUser()
                      );

                      const previous_view_state = getTickerState()
                        .previous_view_state;
                      if (previous_view_state) {
                        setViewState(previous_view_state);
                      } else {
                        setViewState(constants.CALL_VIEW_STATES.CALL_VIEW);
                      }
                    }}
                  >
                    <div className="back-icon click-icon">
                      <img
                        alt=""
                        src={toAbsoluteUrl("/media/sr/icons/ticker-back.svg")}
                      />
                    </div>
                  </a>
                  {props.via !== "crm-customer" && (
                    <div className="back-label">Add/Update Customer</div>
                  )}
                </div>
              )}
              {props.via !== "crm-customer" && (
                <div className="">
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      Tracker.event(
                        crmConstants.ANALYTICS.TICKER_EDIT_SAVE[0],
                        crmConstants.ANALYTICS.TICKER_EDIT_SAVE[1],
                        crmConstants.ANALYTICS.TICKER_EDIT_SAVE[2],
                        crmConstants.ANALYTICS.TICKER_EDIT_SAVE[3],
                        helpers.getUser()
                      );

                      onSave();
                    }}
                  >
                    <img
                      alt=""
                      className="dial-pad-icon click-icon mr-2"
                      src={toAbsoluteUrl("/media/sr/icons/info-save.svg")}
                    />
                  </a>
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      Tracker.event(
                        crmConstants.ANALYTICS.EDIT_CANCEL[0],
                        crmConstants.ANALYTICS.EDIT_CANCEL[1],
                        crmConstants.ANALYTICS.EDIT_CANCEL[2],
                        crmConstants.ANALYTICS.EDIT_CANCEL[3],
                        helpers.getUser()
                      );

                      onCancel();
                    }}
                  >
                    <img
                      alt=""
                      className="dial-pad-icon click-icon"
                      src={toAbsoluteUrl("/media/sr/icons/info-cancel.svg")}
                    />
                  </a>
                </div>
              )}
              {props.via === "crm-customer" && (
                <div className="">
                  <button
                    className="sr-btn px-10 py-2  btn btn-primary mr-2"
                    onClick={() => {
                      Tracker.event(
                        crmConstants.ANALYTICS.EDIT_SAVE[0],
                        crmConstants.ANALYTICS.EDIT_SAVE[1],
                        crmConstants.ANALYTICS.EDIT_SAVE[2],
                        crmConstants.ANALYTICS.EDIT_SAVE[3],
                        helpers.getUser()
                      );

                      onSave();
                    }}
                  >
                    Save
                  </button>
                  <button
                    className="sr-btn px-10 py-2  btn outline-btn"
                    onClick={() => {
                      Tracker.event(
                        crmConstants.ANALYTICS.EDIT_CANCEL[0],
                        crmConstants.ANALYTICS.EDIT_CANCEL[1],
                        crmConstants.ANALYTICS.EDIT_CANCEL[2],
                        crmConstants.ANALYTICS.EDIT_CANCEL[3],
                        helpers.getUser()
                      );

                      onCancel();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </div>
          <div
            className={`update-container ${
              props.via === "crm-customer" ? "max-container" : ""
            }`}
          >
            {msg && (
              <div className="mb-5">
                <Alert msg={msg} onClose={reset} />
              </div>
            )}
            <div className="update-label pi mb-3">PERSONAL INFORMATION</div>
            <div className="mb-5">
              <FormControl fullWidth className="mb-4">
                <OutlineInput
                  placeholderdd="Customer Name"
                  floatingLabel="Customer Name"
                  leadingIcon="cake"
                  trailingIcondd="visibility"
                  name="name"
                  label="Customer Name"
                  value={values.name}
                  validStatus={validations.name}
                  onInputChange={onInputChange}
                  startAdornment={
                    <img
                      alt=""
                      className=""
                      src={toAbsoluteUrl("/media/sr/icons/user-icon.svg")}
                    />
                  }
                  endAdornment={<span className="required-indicator">*</span>}
                />
                {validations &&
                  validations.name === 400 &&
                  (values.name && values.name.length > 0 ? (
                    <FormHelperText className="text-danger">
                      Customer name should be between 3-30 characters
                    </FormHelperText>
                  ) : (
                    <FormHelperText className="text-danger">
                      Required field
                    </FormHelperText>
                  ))}
                {validations && validations.name === 401 && (
                  <FormHelperText className="text-danger">
                    Special Characters are not allowed in the Customer Name
                    field
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth className="mb-4">
                {/**<OutlineInput
                                    placeholderdd='Phone Number'
                                    floatingLabel='Phone Number'
                                    leadingIcon='cake'
                                    trailingIcondd='visibility'
                                    name='number_number' label='Phone Number'
                                    value={values.number_number}
                                    validStatus={validations.number_number}
                                    onInputChange={onInputChange}
                                    startAdornment={
                                        <img
                                        alt="" className="" src={toAbsoluteUrl("/media/sr/icons/icon-number.svg")} />
                                    }
                                    endAdornment=
                                    {<span className="required-indicator">*</span>}

                                />**/}

                {props.via === "crm-customer" && (
                  <>
                    {editMode === "edit" && (
                      <>
                        {phonenumbers_set.map((pn, i) => (
                          <>
                            <div
                              style={{
                                marginBottom: "10px",
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom2: "10px",
                                }}
                              >
                                <TelInput
                                  key={i}
                                  onEvent={(event) => {
                                    onEvent({
                                      ...event,
                                      valueObject: { ...pn },
                                      valueIndex: i,
                                    });
                                  }}
                                  status={validations["number_" + i]}
                                  ticker_initial_customer_number={pn.number}
                                  readOnly={i === 0 ? true : false}
                                  label={"Phone Number"}
                                  valueObject={pn}
                                  valueIndex={i}
                                  startAdornment={
                                    <img
                                      alt=""
                                      className=""
                                      src={toAbsoluteUrl(
                                        "/media/sr/icons/icon-phone.svg"
                                      )}
                                    />
                                  }
                                  moduleName={
                                    props.moduleName ? props.moduleName : ""
                                  }
                                />
                                {i === 0 && (
                                  <a
                                    href="/#"
                                    onClick={(e) => {
                                      let phonenumbers_set1 = [
                                        ...phonenumbers_set,
                                      ];
                                      e.preventDefault();
                                      phonenumbers_set1.push({ number: "" });
                                      setPhonenumbers_set(phonenumbers_set1);
                                    }}
                                  >
                                    <img
                                      alt=""
                                      className=""
                                      src={toAbsoluteUrl(
                                        "/media/sr/icons/circular-plus-icon.svg"
                                      )}
                                    />
                                  </a>
                                )}

                                {i !== 0 && (
                                  <a
                                    href="/#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      let phonenumbers_set1 = [
                                        ...phonenumbers_set,
                                      ];
                                      phonenumbers_set1.splice(i, 1);
                                      setPhonenumbers_set(phonenumbers_set1);
                                    }}
                                  >
                                    <img
                                      alt=""
                                      className=""
                                      src={toAbsoluteUrl(
                                        "/media/sr/icons/circular-minus-icon.svg"
                                      )}
                                    />
                                  </a>
                                )}
                              </span>

                              {validations &&
                                (validations["number_" + i] === 400 ||
                                  validations["number_" + i] === 403) && (
                                  <FormHelperText className="text-danger mt-1">
                                    {getValidationMsg("number_" + i)}
                                  </FormHelperText>
                                )}
                            </div>
                          </>
                        ))}
                      </>
                    )}
                  </>
                )}

                {props.via !== "crm-customer" && (
                  <TelInput
                    onEvent={onEvent}
                    status={validations.number}
                    ticker_initial_customer_number={values.number}
                    readOnly={true}
                    label={"Phone Number"}
                    moduleName={props.moduleName ? props.moduleName : ""}
                    startAdornment={
                      <img
                        alt=""
                        className=""
                        src={toAbsoluteUrl("/media/sr/icons/icon-phone.svg")}
                      />
                    }
                  />
                )}

                {validations &&
                  (validations["number"] === 400 ||
                    validations["number"] === 403) && (
                    <FormHelperText className="text-danger mt-1">
                      {getValidationMsg("number")}
                    </FormHelperText>
                  )}
              </FormControl>
            </div>
            <div className="update-label bi">BUSINESS INFORMATION</div>
            {props.via === "crm-customer" && (
              <>
                <div className="lead-status">Lead Status</div>
                <div className="lead-status-sec mb-5">
                  <a
                    className="w-link"
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      onInputChange("status", "Hot");
                    }}
                  >
                    <div
                      className={`lead-type ${
                        values.status === "Hot" ? "active" : ""
                      }`}
                    >
                      <div className="ld-type-icon">
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl("/media/sr/icons/lead-hot.svg")}
                        />
                      </div>
                      <div className="ld-type-label">Hot</div>
                    </div>
                  </a>
                  <a
                    className="w-link"
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      onInputChange("status", "Warm");
                    }}
                  >
                    <div
                      className={`lead-type ${
                        values.status === "Warm" ? "active" : ""
                      }`}
                    >
                      <div className="ld-type-icon">
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl("/media/sr/icons/lead-warm.svg")}
                        />
                      </div>
                      <div className="ld-type-label">Warm</div>
                    </div>
                  </a>
                  <a
                    className="w-link"
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      onInputChange("status", "Cold");
                    }}
                  >
                    <div
                      className={`lead-type ${
                        values.status === "Cold" ? "active" : ""
                      }`}
                    >
                      <div className="ld-type-icon">
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl("/media/sr/icons/lead-cold.svg")}
                        />
                      </div>
                      <div className="ld-type-label">Cold</div>
                    </div>
                  </a>

                  <a
                    className="w-link"
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      onInputChange("status", "Closed");
                    }}
                  >
                    <div
                      className={`lead-type ${
                        values.status === "Closed" ? "active" : ""
                      }`}
                    >
                      <div className="ld-type-icon">
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl("/media/sr/icons/lead-closed.svg")}
                        />
                      </div>
                      <div className="ld-type-label">Closed</div>
                    </div>
                  </a>
                </div>
              </>
            )}

            <div className="mb-5">
              <FormControl fullWidth className="mb-4">
                <OutlineInput
                  placeholderdd="Email"
                  floatingLabel="Email"
                  leadingIcon="cake"
                  trailingIcondd="visibility"
                  name="email"
                  label="Email"
                  value={values.email}
                  validStatus={validations.email}
                  onInputChange={onInputChange}
                  startAdornment={
                    <img
                      alt=""
                      className=""
                      src={toAbsoluteUrl("/media/sr/icons/email-icon.svg")}
                    />
                  }
                  endAdornment={<></>}
                />
                {validations && validations.email === 400 && (
                  <FormHelperText className="text-danger">
                    Please enter a valid email address
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth className="mb-4">
                <OutlineInput
                  placeholderdd="Company Name"
                  floatingLabel="Company Name"
                  leadingIcon="cake"
                  trailingIcondd="visibility"
                  name="company"
                  label="Company Name"
                  value={values.company}
                  validStatus={validations.company}
                  onInputChange={onInputChange}
                  startAdornment={
                    <img
                      alt=""
                      className=""
                      src={toAbsoluteUrl("/media/sr/icons/company.svg")}
                    />
                  }
                  endAdornment={<></>}
                />
                {validations && validations.company === 400 && (
                  <FormHelperText className="text-danger">
                    Company Name should be between 3-50 characters
                  </FormHelperText>
                )}
              </FormControl>

              <FormControl fullWidth className="mb-4">
                <OutlineInput
                  placeholderdd="Field 1"
                  floatingLabel="Field 1"
                  leadingIcon="cake"
                  trailingIcondd="visibility"
                  name="additional_info_1"
                  label="Field 1"
                  value={values.additional_info_1}
                  validStatus={validations.additional_info_1}
                  maxLength={100}
                  onInputChange={onInputChange}
                />
              </FormControl>
              <FormControl fullWidth>
                <OutlineInput
                  placeholderdd="Field 2"
                  floatingLabel="Field 2"
                  leadingIcon="cake"
                  trailingIcondd="visibility"
                  name="additional_info_2"
                  label="Field 2"
                  value={values.additional_info_2}
                  validStatus={validations.additional_info_2}
                  maxLength={100}
                  onInputChange={onInputChange}
                />
              </FormControl>
            </div>

            {props.via !== "crm-customer" && (
              <>
                <div className="lead-status">Lead Status</div>
                <div className="lead-status-sec mb-5">
                  <a
                    className="w-link"
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      onInputChange("status", "Hot");
                    }}
                  >
                    <div
                      className={`lead-type ${
                        values.status === "Hot" ? "active" : ""
                      }`}
                    >
                      <div className="ld-type-icon">
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl("/media/sr/icons/lead-hot.svg")}
                        />
                      </div>
                      <div className="ld-type-label">Hot</div>
                    </div>
                  </a>
                  <a
                    className="w-link"
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      onInputChange("status", "Warm");
                    }}
                  >
                    <div
                      className={`lead-type ${
                        values.status === "Warm" ? "active" : ""
                      }`}
                    >
                      <div className="ld-type-icon">
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl("/media/sr/icons/lead-warm.svg")}
                        />
                      </div>
                      <div className="ld-type-label">Warm</div>
                    </div>
                  </a>
                  <a
                    className="w-link"
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      onInputChange("status", "Cold");
                    }}
                  >
                    <div
                      className={`lead-type ${
                        values.status === "Cold" ? "active" : ""
                      }`}
                    >
                      <div className="ld-type-icon">
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl("/media/sr/icons/lead-cold.svg")}
                        />
                      </div>
                      <div className="ld-type-label">Cold</div>
                    </div>
                  </a>

                  <a
                    className="w-link"
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      onInputChange("status", "Closed");
                    }}
                  >
                    <div
                      className={`lead-type ${
                        values.status === "Closed" ? "active" : ""
                      }`}
                    >
                      <div className="ld-type-icon">
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl("/media/sr/icons/lead-closed.svg")}
                        />
                      </div>
                      <div className="ld-type-label">Closed</div>
                    </div>
                  </a>
                </div>
                {is_disposition_enabled && (
                  <div className="mb-5 row">
                    <div className="col-12 col-lg-6">
                      <FormControl fullWidth className="mb-4">
                        <OpcSelect
                          isMobile={props.isMobile}
                          type="dispositions"
                          placeholder="Dispositions"
                          searchPlaceholder="Search"
                          selected={selectedDisposition}
                          onSelect={onSelectDisposition}
                          showSelectedLabel={true}
                          showSecondarySelectedLabel={true}
                          showOptionLabel={true}
                          showSecondaryOptionLabel={true}
                          customLabels={customLabelsForDispositions}
                          countries={valueCodesForDispositions}
                          searchable={false}
                          placeholderIcon={false}
                          optionItemIcon={false}
                        />
                      </FormControl>
                    </div>

                    <div className="col-12 col-lg-6">
                      <FormControl
                        fullWidth
                        className="mb-4"
                        disabled={
                          !selectedDisposition ||
                          !valueCodesForSubDispositions ||
                          valueCodesForSubDispositions.length === 0
                        }
                      >
                        <OpcSelect
                          isMobile={props.isMobile}
                          type="sub_dispositions"
                          placeholder="Sub Dispositions"
                          searchPlaceholder="Search"
                          selected={selectedSubDisposition}
                          onSelect={onSelectSubDisposition}
                          showSelectedLabel={true}
                          showSecondarySelectedLabel={true}
                          showOptionLabel={true}
                          showSecondaryOptionLabel={true}
                          customLabels={customLabelsForSubDispositions}
                          countries={valueCodesForSubDispositions}
                          searchable={false}
                          disbaled={
                            !selectedDisposition ||
                            !valueCodesForSubDispositions ||
                            valueCodesForSubDispositions.length === 0
                          }
                          placeholderIcon={false}
                          optionItemIcon={false}
                          customPadding={5}
                        />
                      </FormControl>
                    </div>
                  </div>
                )}
                <div className="add-note-sec mb-5">
                  <div className="d-flex justify-content-between mb-4">
                    <div>
                      <span className="mr-4">
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl("/media/sr/icons/add-note.svg")}
                        />
                      </span>
                      <span className="sec-label">Add Note</span>
                    </div>
                    <div>
                      <a
                        href="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggle("note");
                        }}
                      >
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl(
                            `/media/sr/icons/${
                              noteOpenState ? "minus" : "plus"
                            }.svg`
                          )}
                        />
                      </a>
                    </div>
                  </div>
                  {noteOpenState && (
                    <div>
                      <textarea
                        maxLength={256}
                        value={values.note}
                        style={{ resize: "none" }}
                        onChange={(e) => {
                          onInputChange("note", e.target.value);
                        }}
                        placeholder="Type note here…"
                        row="3"
                      ></textarea>
                      <div className="text-muted mt-4">
                        {256 - (values.note ? values.note.length : 0)}{" "}
                        characters remaining
                      </div>
                    </div>
                  )}

                  {helpers.isAdmin() ||
                    (helpers.isSuperVisor() && assignedLeadObject && (
                      <>
                        <div className="lead-status pt-1">Assign Lead</div>
                        {props.assignLeadView ? (
                          React.cloneElement(props.assignLeadView, {
                            getAssignLeadData: getAssignLeadData,
                            customer: {
                              ...customer,
                              agent_object: assignedLeadObject,
                            },
                          })
                        ) : (
                          <></>
                        )}
                      </>
                    ))}
                </div>
                <div className="add-followup-sec">
                  <div className="d-flex justify-content-between mb-4">
                    <div>
                      <span className="mr-4">
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl(
                            "/media/sr/icons/calendar-icon.svg"
                          )}
                        />
                      </span>
                      <span className="sec-label">Add Follow-Up</span>
                    </div>
                    <div>
                      <a
                        href="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggle("fnote");
                        }}
                      >
                        <img
                          alt=""
                          className=""
                          src={toAbsoluteUrl(
                            `/media/sr/icons/${
                              fnoteOpenState ? "minus" : "plus"
                            }.svg`
                          )}
                        />
                      </a>
                    </div>
                  </div>
                  <div className="mb-4">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DateTimePicker
                        label="Date & Time"
                        fullWidth={true}
                        disablePast={true}
                        minDate={moment().toDate()}
                        ampm={false}
                        error={validations && validations.followup_dt === 400}
                        minDateMessage="Follow up time should be greater than current time"
                        onOpen={() => {
                          dispatch({
                            type: actionTypes.onCallViewState,
                            payload: { drag: false },
                          });
                        }}
                        onClose={() => {
                          dispatch({
                            type: actionTypes.onCallViewState,
                            payload: { drag: true },
                          });
                        }}
                        inputVariant="outlined"
                        format="MMM dd yyyy, HH:mm"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton>
                                <img
                                  alt=""
                                  className=""
                                  src={toAbsoluteUrl(
                                    "/media/sr/icons/date-time-icon.svg"
                                  )}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </MuiPickersUtilsProvider>

                    {validations && validations.followup_dt === 400 && (
                      <FormHelperText className="text-danger">
                        Follow up time should be greater than current time
                      </FormHelperText>
                    )}
                  </div>
                  {fnoteOpenState && (
                    <div>
                      <div className="note-label">Note</div>
                      <div className="note-list">
                        <textarea
                          maxLength={256}
                          style={{ resize: "none" }}
                          value={values.followup_notes}
                          onChange={(e) => {
                            onInputChange("followup_notes", e.target.value);
                          }}
                          placeholder="Type note here…"
                          row="3"
                        ></textarea>
                        <div className="text-muted mt-4">
                          {256 -
                            (values.followup_notes
                              ? values.followup_notes.length
                              : 0)}{" "}
                          characters remaining
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
